import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { AbilityChartPresentation } from "home/components/socioemotional"
import { mockBarChartAbilities } from "home/components/socioemotional"

class AbilityChartContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      chartPatch: null
    }
  }

  componentDidMount () {
    // this.updateData()
    this.updateMockData()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.filters.schoolId !== this.props.filters.schoolId) {
      this.updateData()
    }
  }

  updateMockData () {
      this.setChartConfigFromResponse(mockBarChartAbilities)
  }

  updateData () {
    const { filters } = this.props

    requestResource("profile/licences_activations", filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
      console.log("response",response)
    this.setState({
      chartPatch: response.data.patch
    })
  }

  render () {
    if (this.state.chartPatch === null) {
      return <div>Aguardando dados</div>
    } else {
      return <AbilityChartPresentation patch={this.state.chartPatch} />
    }
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      schoolId: state.filters.schoolId
    }
  }
}

export default connect(mapStateToProps)(AbilityChartContainer)
